function closeMenus() {
    $('[data-menu]').removeClass('active');
    $("[data-opens-menu]").removeClass("active");
    $('[data-hide-mobile-menu]').hide();
    $('[data-show-mobile-menu]').show();
}

function showMobileSearch() {
    closeMenus();

    //hide menu links
    $('.header-2024-mobile-menu-icons').hide();

    //hide search icon
    $('.header-2024-mobile-search-icon-container').hide();

    //show search close icon
    $('.header-2024-mobile-search-close-icon').show();

    //show search     
    $('.header-2024-mobile-search').addClass("active");

    //add header-menu-opened from body
    $('body').addClass('header-menu-opened');
}

window.hideMobileSearch = function() {
    //hide search
    $('.header-2024-mobile-search').removeClass("active");

    //hide close search icon
    $('.header-2024-mobile-search-close-icon').hide();

    //show search icon
    $('.header-2024-mobile-search-icon-container').show();

    //show menu icons
    $('.header-2024-mobile-menu-icons').show();

    $('[data-open-mobile-menu]').show();

    //remove header-menu-opened to body
    $('body').removeClass('header-menu-opened');
}

function showMobileMenu() {
    //close the search
    hideMobileSearch();

    $('[data-open-mobile-menu]').hide();
    $('[data-hide-mobile-menu]').show();
    $('.header-2024-main').addClass('active');

    //add header-menu-opened to body
    $('body').addClass('header-menu-opened');
}

function hideMobileMenu() {
    $('[data-hide-mobile-menu]').hide();
    $('[data-open-mobile-menu]').show();
    $('.header-2024-main').removeClass('active');
    $('.header-2024-main-dropdown-link').removeClass('active');
    $('.header-2024-main-dropdown-container').removeClass('active');
    //remove header-menu-opened to body
    $('body').removeClass('header-menu-opened');
}

//close the dropdown menu when clicking outside it (but also not the activatable link)
$(document).click(function (event) {
    var $activeMenus = $('.header-2024-main-dropdown-container.active').length;
    if ($activeMenus) {
        var $target = $(event.target);
        var attr = $target[0].hasAttribute('data-opens-menu');
        //if the current target isn't the menu itself, isn't the button that activates the menu, and isn't a child of the button that activates it
        if (!attr && !$target.closest('.header-2024-main-dropdown-container').length && !$target.closest(".header-2024-mobile").length && !$target.closest('[data-opens-menu]').length) {
            //hide the menu
            hideMobileMenu();
        }
    }
});

$('[data-show-search]').on('click', function () {
    showMobileSearch();
});

$('[data-hide-search]').on('click', function () {
    hideMobileSearch();
});

$('[data-open-mobile-menu]').on('click', function () {
    showMobileMenu();
});

$('[data-hide-mobile-menu]').on('click', function () {
    hideMobileMenu();
});

function closeDropdownMenu(elem) {
    //get the menu id 
    var dropdownMenuContainer = $(elem).closest('.header-2024-main-dropdown-container');
    //find your parent and remove your active class
    dropdownMenuContainer.removeClass('active');
    //find your parent's siblign and remove their active class
    $("[data-opens-menu='" + $(dropdownMenuContainer).attr('data-menu') + "']").removeClass("active");
}

$('[data-dropdownmenu-close]').on('click', function () {
    closeDropdownMenu($(this));
});

$('[data-opens-menu]').on('click', function () {
    var target = $(this).attr('data-opens-menu');
    if (target.length) {
        $(this).toggleClass('active');
        $("[data-menu='" + target + "']").toggleClass("active");

        //is opened
        if ($(this).hasClass('active')) {
            $('body').addClass('header-menu-opened');
            showMobileMenu();
        }
        //is closed
        else {
            $('body').removeClass('header-menu-opened');
            hideMobileMenu();
        }
    }
});

$('[data-menu-open]').on('click', function () {
    $('.header-2024-main').toggleClass('active');
    $(this).hide();
    $('[data-menu-close]').show();

    if ($('.header-2024-main').hasClass('active')) {
        $('.header-2024-main-dropdown-link').removeClass('active');
        $('body').addClass('header-menu-opened');
    }
    else {
        $('body').removeClass('header-menu-opened');
    }
});

function clearInput(elem) {
    $(elem).val('');
}

$('[data-clear-input]').on('click', function () {
    clearInput($(this).attr('data-clear-input'));
});

//offsets component anchors to compensate for current height of the header and in page navigation
window.offsetHeaderInPageNavigationAnchors = function () {

    var headerElement = $('#header');
    var anchorOffset;
    
    if (headerElement === null || headerElement.length <= 0) {
        headerElement = $('.header-sticky-container');
    }

    if (headerElement.length) {
        anchorOffset = $(headerElement).outerHeight() + 1;
    }

    if (anchorOffset) {
        $('[data-scroll-margin-top]').css("scroll-margin-top", anchorOffset);
        $('[id]').css("scroll-margin-top", anchorOffset);
    }
}

$(window).on('load', function () {
    offsetHeaderInPageNavigationAnchors();
});

$(window).on('resize', throttle(function () {
    offsetHeaderInPageNavigationAnchors();
}, 400));

// Declare the necessary variables in the global scope
var lastScrollTop = 0;
var $localNav = $('.baptist-2025-local-navigation-mobile');
var $mobileHeader = $('.header-2024-mobile');

// Function to determine scroll direction
function checkScrollDirection() {
    var scrollTop = $(window).scrollTop();
    var direction = (scrollTop > lastScrollTop) ? 'down' : 'up';
    lastScrollTop = scrollTop;
    return direction; // Return the scroll direction
}

// Function to apply the effects based on scroll direction
function hideMobileNavigation() {
    var direction = checkScrollDirection(); // Get scroll direction by calling checkScrollDirection
    var mobileHeaderHeight = $mobileHeader.outerHeight();

    if (direction === 'down') {
        $mobileHeader.css('transform', 'translateY(-' + mobileHeaderHeight + 'px)');
        $localNav.css('transform', 'translateY(-' + mobileHeaderHeight + 'px)');
    } else {
        $mobileHeader.css('transform', '');
        $localNav.css('transform', '');
    }
}

// Document ready function to attach event listeners
$(document).ready(function () {

    if ($localNav.length) {
        // Run once on page load to set the initial state
        hideMobileNavigation(); // Apply effect after checking scroll direction

        // Attach scroll event with throttle for performance improvement
        var throttledApplyScrollEffect = window.throttle(hideMobileNavigation, 100);
        $(window).on('scroll', throttledApplyScrollEffect);
    }
});

